<template>
	<div class="personal-box">
		<el-dialog
			:title="titleshow == 1 ? $t('Personal.SetPassword') : $t('Personal.ChangePassword')"
			:visible.sync="show"
			width="600px">
			<div v-if="titleshow == 1">
				<el-form :model="setupPassword" :rules="setupRules" ref="setupPassword" class="demo-ruleForm" label-width="150px">
					<el-form-item prop="password" :label="`${$t('Personal.PleaseEnterPassword')}:`">
						<el-input
							size="small"
							type="password"
							prefix-icon="iconfont icon-mima"
							v-model="setupPassword.password"
							autocomplete="off"
							:placeholder="$t('Personal.PleaseEnterPassword')"
						></el-input>
					</el-form-item>
					<el-form-item prop="againpassword" :label="`${$t('Personal.PleaseEnterPasswordAgain')}:`">
						<el-input
							size="small"
							type="password"
							prefix-icon="iconfont icon-mima"
							v-model="setupPassword.againpassword"
							autocomplete="off"
							:placeholder="$t('Personal.PleaseEnterPasswordAgain')"
						></el-input>
					</el-form-item>
				</el-form>
			</div>
			<div v-if="titleshow == 2">
				<el-form :model="changePassword" :rules="changeRules" ref="changePassword"  label-width="150px">
					<el-form-item prop="oldPassword" :label="`${$t('Personal.PleaseEnterOldPassword')}:`">
						<el-input
							size="small"
							type="password"
							prefix-icon="iconfont icon-mima"
							v-model="changePassword.oldPassword"
							autocomplete="off"
							:placeholder="$t('Personal.PleaseEnterOldPassword')"
						></el-input>
					</el-form-item>
					<el-form-item prop="newPassword" :label="`${$t('Personal.PleaseEterNewPassword')}:`">
						<el-input
							size="small"
							type="password"
							prefix-icon="iconfont icon-mima"
							v-model="changePassword.newPassword"
							autocomplete="off"
							:placeholder="$t('Personal.PleaseEterNewPassword')"
						></el-input>
					</el-form-item>
					<el-form-item prop="againnewPassword" :label="`${$t('Personal.PleaseEnterNewPasswordAgain')}:`">
						<el-input
							size="small"
							type="password"
							prefix-icon="iconfont icon-mima"
							v-model="changePassword.againnewPassword"
							autocomplete="off"
							:placeholder="$t('Personal.PleaseEnterNewPasswordAgain')"
						></el-input>
					</el-form-item>
				</el-form>
			</div>
			<span slot="footer" class="dialog-footer">
				<!-- <el-button @click="dialogVisible = false">取 消</el-button> -->
				<el-button size="small" type="primary" @click="setPasswordChange">{{$t('main.ok')}}</el-button>
			</span>
		</el-dialog>
		<div v-if="headerShow" class="mask"></div>
		<div v-if="headerShow" class="details2">
			<div class="headerShow">
				<span class="modifyHeader">{{$t('Personal.ModifyAvatar')}}</span>
				<i class="el-icon-close close" @click="closeBox"></i>
			</div>
			<div class="boxcontent">
				<div class="boxLeft">
					<el-upload
						class="avatar-uploader"
						ref="upload"
						:action="$config.service.uploadApi"
						:show-file-list="false"
						:on-success="handleSuccess"
						:before-upload="beforeAvatarUpload"
						:data="QiniuData"
						:on-remove="handleRemove"
						:multiple="false"
						:limit="1"
					>
						<el-button type="primary" size="small">{{$t('Personal.LocalUpload')}}</el-button>
					</el-upload>
					<p class="uploadTips">{{$t('Personal.LocalUploadTip')}}</p>
				</div>
				<div class="boxRight">
					<p>{{$t('Personal.EffectPreview')}}</p>
					<img :src="header" />
					<span>{{$t('Personal.Pixels')}}</span>
				</div>
			</div>
			<div class="buttonBox">
				<el-button size="small" type="primary" @click="saveHeader()">{{$t('main.save')}}</el-button>
			</div>
		</div>

		<div style="background: #fff">
			<div class="w">
				<SecondHead textColor="#333" color="#333" ref="myHeader"></SecondHead>
			</div>
		</div>

		<div class="personalBox">
			<div class="titleBox">
				<div class="p_line"></div>
				<span>{{$t('Personal.UserInformation')}}</span>
			</div>
			<div class="personal-content">
				<el-form :label-position="labelPosition" label-width="116px" :model="formLabelAlign">
					<div class="contentItem">
						<el-form-item :label="$t('Personal.HeadPortrait')">
							<div class="itemBox">
								<div class="content">
									<img v-if="formLabelAlign.heaPath && formLabelAlign.heaPath != 'touxiang.png'" class="headerImg" :src="formLabelAlign.heaPath" alt="" />
									<img v-else class="headerImg" src="../assets/default-imgs/touxiang.png" alt="" />
								</div>
								<div class="btnBox">
									<el-button type="text" @click="avatar(formLabelAlign.heaPath)">{{$t('Personal.ReplaceAvatar')}}</el-button>
								</div>
							</div>
						</el-form-item>
					</div>
					<div class="contentItem">
						<el-form-item :label="$t('Personal.UserName')">
							<div class="itemBox">
								<div class="content">
									<el-input size="small" :disabled="true" v-model="formLabelAlign.loginname" :placeholder="$t('Personal.EnterUserName')"></el-input>
									<div class="tips">
										<span class="asterisk">*</span>
										<span class="tipsText">{{$t('Personal.UserNameCanOnlyModifiedOnce')}}</span>
									</div>
								</div>
								<div class="btnBox">
									<el-button type="text" @click="dialogName = true" v-if="formLabelAlign.isLoginname == 0">{{$t('main.modify')}}</el-button>
									<el-dialog :title="$t('Personal.ModifyUserName')" :visible.sync="dialogName" width="30%" :before-close="handleClose" :close-on-click-modal="false">
										<span>{{$t('Personal.NewUsername')}}：</span>
										<el-input size="small" v-model="formLabelAlign.loginname" style="width: 70%;"></el-input>
										<span slot="footer" class="dialog-footer">
											<el-button size="small" @click="dialogName = false">{{$t('main.cancel2')}}</el-button>
											<el-button size="small" type="primary" @click="dialogNameAlter">{{$t('main.ok2')}}</el-button>
										</span>
									</el-dialog>
								</div>
							</div>
						</el-form-item>
					</div>
					<div class="contentItem">
						<el-form-item :label="$t('Personal.CellPhoneNumber')">
							<div class="itemBox">
								<div class="content">
									<el-input size="small" :disabled="true" v-model="formLabelAlign.contactNumber" :placeholder="$t('Personal.PleaseEnterPhoneNumber')"></el-input>
									<div class="tips" v-if="formLabelAlign.contactNumber==''">
										<span class="asterisk">*</span>
										<span class="tipsText">{{$t('Personal.PleaseBindPhoneNumber')}}</span>
									</div>
								</div>
								<div class="btnBox">
									<el-button type="text" v-if="formLabelAlign.contactNumber!==''" @click="centerDialogVisible = true">{{$t('Personal.UnbindPhoneNumber')}}</el-button>
									<el-button type="text" v-else @click="centerDialogVisible = true">{{$t('Personal.BindPhoneNumber')}}</el-button>
									<el-dialog
										:title="$t('main.tip')"
										:visible.sync="centerDialogVisible"
										width="400px" :close-on-click-modal="false">
										<div class="phoneNumberBox">
											<div class="phoneNumber">
												<el-input size="small" v-model="phoneNumber" :placeholder="$t('Personal.PleaseEnterYourPhoneNumber')"></el-input>
											</div>
											<div class="verificationCodeBox">
												<el-input  size="small" :placeholder="$t('Personal.PleaseEnterVerificationCode')" v-model="verificationCode">
													<el-button  size="small" v-if="sendVerificationCode" slot="append" @click="sendCode">{{$t('Personal.SendVerificationCode')}}</el-button>
													<el-button  size="small" v-else slot="append" :disabled="true">{{$t('Personal.Resend')}} {{ seconds }}</el-button>
												</el-input>
												<!-- <span class="tips" style="line-height: 15px;">建议您确认已绑定QQ或微信，以便在解绑手机号之后，仍然可以顺利登录。国信办规定，发布信息必须绑定手机号，请解绑后及时绑定新手机号。</span> -->
											</div>
										</div>
										<span slot="footer" class="dialog-footer">
											<el-button size="small" @click="centerDialogVisible = false">{{$t('main.cancel2')}}</el-button>
											<el-button size="small" v-if="!isBind" type="primary" @click="savePhoneNumber(1)">{{$t('main.ok2')}}</el-button>
											<el-button size="small" v-else type="primary" @click="savePhoneNumber(2)">{{$t('main.ok2')}}</el-button>
										</span>
									</el-dialog>
								</div>
							</div>
						</el-form-item>
					</div>
					<div class="contentItem">
						<el-form-item :label="$t('Personal.Password')">
							<div class="itemBox">
								<div class="content">
									<el-input size="small" :disabled="true" type="password" v-model="passwordnone" :placeholder="$t('Personal.SetPassword')"></el-input>
								</div>
								<div class="btnBox">
									<el-button type="text"  v-if="formLabelAlign.status == 0" @click="passwordamend(1)">{{$t('Personal.SetPassword')}}</el-button>
									<el-button type="text"  v-if="formLabelAlign.status == 1" @click="passwordamend(2)">{{$t('Personal.ChangePassword')}}</el-button>
								</div>
							</div>
						</el-form-item>
					</div>
					<div class="contentItem">
						<el-form-item :label="$t('Personal.Mailbox')">
							<div class="itemBox">
								<div class="content">
									<el-input size="small" :disabled="true" type="email" v-model="formLabelAlign.email" :placeholder="$t('Personal.SetUpEmail')"></el-input>
								</div>
								<div class="btnBox">
									<el-button v-if="formLabelAlign.email.length == 0" type="text" @click="dialogVisible = true">{{$t('Personal.BindEmail')}}</el-button>
									<el-button v-else type="text" @click="dialogVisible = true">{{$t('Personal.ModifyEmail')}}</el-button>
									<el-dialog :title="$t('Personal.VerifyEmailAddress')" :visible.sync="dialogVisible" width="500px" :close-on-click-modal="false">
										<span>
											{{$t('Personal.EmailAddress')}} ：
											<el-input size="small" v-model="emailEmail" style="width: 80%;"></el-input>
										</span>
										<span slot="footer" class="dialog-footer">
											<el-button size="small" type="primary" @click="sendBindEmail">{{$t('Personal.SendVerificationEmail')}}</el-button>
										</span>
									</el-dialog>

									<el-dialog :title="$t('Personal.SendEmail')" :visible.sync="dialogVisible2" width="40%" border-radius="10px" :before-close="handleClose" :close-on-click-modal="false">
										<span>{{$t('Personal.SentTo')}}{{ emailEmail }}{{$t('Personal.PleaseCheckEmail')}}</span>
										<span slot="footer" class="dialog-footer">
											<span>
												{{$t('Personal.NoEmailReceived')}}
												<a @click="sendBindEmail" style="cursor: pointer;">{{$t('Personal.Resend')}}</a>
											</span>
										</span>
									</el-dialog>
								</div>
							</div>
						</el-form-item>
					</div>
					<div class="contentItem">
						<el-form-item :label="$t('Personal.FullName')">
							<div class="itemBox">
								<div class="content">
									<el-input size="small" :disabled="isEditName" v-model="formLabelAlign.username" :placeholder="$t('Personal.PleaseEnterYourName')"></el-input>
								</div>
								<div class="btnBox">
									<el-button type="text" v-if="!isEditName" @click="saveName">{{$t('main.save')}}</el-button>
									<el-button type="text" style="color: #F56C6C;" v-if="!isEditName" @click="isEditName = true">{{$t('main.cancel')}}</el-button>
									<el-button type="text" v-else @click="isEditName = false">{{$t('main.modify')}}</el-button>
								</div>
							</div>
						</el-form-item>
					</div>
					<div class="contentItem">
						<el-form-item :label="$t('Personal.Address')">
							<div class="itemBox">
								<div class="content">
									<el-row :gutter="20">
										<el-col :span="8">
											<el-select size="small" :disabled="!isEditAddress" v-model="formLabelAlign.province" :placeholder="$t('Personal.PleaseSelectProvince')" @change="loadLinkage" value-key="id">
												<el-option v-for="item in provinceList" :key="item.id" :label="item.name" :value="item"></el-option>
											</el-select>
										</el-col>
										<el-col :span="8">
											<el-select size="small" :disabled="!isEditAddress" v-model="formLabelAlign.city" :placeholder="$t('Personal.PleaseSelectCity')" style="margin-left: 10px" value-key="id" @change="loadXian">
												<el-option v-for="item in cityList" :key="item.id" :label="item.name" :value="item"></el-option>
											</el-select>
										</el-col>
										<el-col :span="8">
											<el-select size="small" :disabled="!isEditAddress" v-model="formLabelAlign.county" :placeholder="$t('Personal.PleaseSelectCounty')" value-key="id" style="margin-left: 10px" @change="loadCounty">
												<el-option v-for="item in xianList" :key="item.id" :label="item.name" :value="item"></el-option>
											</el-select>
										</el-col>
									</el-row>
								</div>
								<div class="btnBox">
									<el-button type="text" v-if="isEditAddress" @click="saveAddress">{{$t('main.save')}}</el-button>
									<el-button type="text" v-if="isEditAddress"  style="color: #F56C6C;" @click="cancel">{{$t('main.cancel')}}</el-button>
									<el-button type="text" v-if="!isEditAddress" @click="isEditAddress = !isEditAddress">{{$t('Personal.ModifyAddress')}}</el-button>
								</div>
							</div>
						</el-form-item>
					</div>
				</el-form>
			</div>
		</div>
	</div>
</template>

<script>
import SecondHead from '@/components/SecondHead';
import { mapState } from "vuex"
export default {
	name: 'Personal',
	components: {
		SecondHead
	},
	data() {
		return {
			isBind:false,
			isEditAddress:false,
			isEditName:true,
			centerDialogVisible:false,
			sendVerificationCode:true,
			phoneNumber:'',
			verificationCode:'',
			seconds: 59,
			time:'',
			resPhoneNumber:'',
			loginNameset: ' ', // 修改新用户名
			dialogName: false, //对话框 修改名字
			dialogVisible2: false, //等待邮箱发送成功
			dialogVisible: false, //绑定邮箱
			labelPosition: 'right',
			emailEmail: '',
			formLabelAlign: {
				contactNumber: '',
				email: '',
				loginname: '',
				province: '',
				city: '',
				heaPath: '',
				username: '',
				status: '',
				county: ''
			},
			provinceList: [],
			cityList: [],
			token: '',
			passwordnone: 123456,
			passwordset: '',
			show: false,
			titleshow: 1,
			setupPassword: {
				password: '',
				againpassword: ''
			},
			changePassword: {
				oldPassword: '',
				newPassword: '',
				againnewPassword: ''
			},
			setupRules: {
				password: [{ required: true, message: this.$t('Personal.PleaseEnterPassword'), trigger: 'blur' }],
				againpassword: [{ required: true, message: this.$t('Personal.PleaseEnterPasswordAgain'), trigger: 'blur' }]
			},
			changeRules: {
				oldPassword: [{ required: true, message: this.$t('Personal.PleaseEnterOldPassword2'), trigger: 'blur' }],
				newPassword: [{ required: true, message: this.$t('Personal.PleaseEterNewPassword2'), trigger: 'blur' }],
				againnewPassword: [{ required: true, message: this.$t('Personal.PleaseEnterNewPasswordAgain'), trigger: 'blur' }]
			},
			xianList: [],
			headerShow: false,
			header: require('@/assets/default-imgs/touxiang.png'),
			touxiang: require('@/assets/default-imgs/touxiang.png'),
			QiniuData: {
				biz: 'userHeader',
				data: {}
			},
			uploadPicUrl: '',
			fileList: []
		};
	},
	watch:{
		seconds(newVal) {
			this.num(newVal);
		},
	},
	computed: {
    	...mapState(['headers']),
	},
	methods: {
		num(n) {
			if (this.seconds === 0) {
				window.clearInterval(this.time);
				this.sendVerificationCode = true
				this.seconds = 59;
				return false
			}
			return n < 10 ? '0' + n : '' + n;
		},
		// 倒计时
		timer() {
			this.time = window.setInterval(() => {
				if (this.seconds === 0) {
					this.seconds = 59;
					window.clearInterval(this.time);
				} else {
					this.seconds--
				}
			}, 1000);
		},
		sendCode(){
			if(this.phoneNumber !== ''){
				let reg = /^1[3456789]\d{9}$/;
				if (reg.test(this.phoneNumber)) {
					this.sendVerificationCode = false
					this.timer();
					let data = {
						phone: this.phoneNumber,
						state:''
					}
					this.sendPhoneCode(data)
				} else {
					this.$message.error(this.$t('Personal.PleaseEnterCorrectPhoneNumber'));
					return false;
				}
			}else {
				this.$message.error(this.$t('Personal.PhoneNumberCannotEmpty'));
				return false;
			}
		},
		sendPhoneCode(data){
			let that = this;
			let params = {
				that: this,
				method: 'POST',
				url: this.$config.service.sendPhoneCode,
				data: { ...data },
				cb(res) {
					if (res.code == 0) {
						console.log(res)
					}else{
						window.clearInterval(this.time);
						that.sendVerificationCode = true
						that.seconds = 59;
						that.$message.error(res.message)
					}
				}
			};
			that.$util.request(params);
		},
		dialogNameAlter() {
			let that = this
			if (that.formLabelAlign.loginname == ' ' ) {
				that.$message.error(that.$t('Personal.UserNameCannotEmpty'));
				return false
			}
			let params = {
				that: this,
				method: 'POST',
				url: `${this.$config.service.modifyLoginName}?loginName=${that.formLabelAlign.loginname} `,
				cb(res) {
					if (res.code == 0) {
						that.formLabelAlign.isLoginname = 1
						that.$message.success(res.message);
						that.dialogName = false;
					} else {
						that.$message.error(res.message);
					}
				}
			};
			this.$util.request(params);
		},
		handleClose(done) {
			//点击遮罩层关闭
			done();
		},
		sendBindEmail() {
			// 绑定邮箱
			let that = this;
			let email = this.emailEmail;
			let reg = /^[a-zA-Z0-9]+([-_.][a-zA-Z0-9]+)*@[a-zA-Z0-9]+([-_.][a-zA-Z0-9]+)*\.[a-z]{2,}$/;
			if (email.length == 0) {
				this.$message.error(this.$t('Personal.PleaseFillEmailAddress'));
				return false;
			}
			if (!reg.test(email)) {
				this.$message.error(this.$t('Personal.PleaseFillCorrectEmailAddress'));
				return false;
			} else {
				let params = {
					that: this,
					method: 'GET',
					url: `${this.$config.service.sendBindEmail}?email=${email}&action=bind`,
					cb(res) {
						if (res.code == 0) {
							that.dialogVisible = false;
							that.dialogVisible2 = true;
							that.$message.success(res.message);
						} else {
							that.$message.error(res.message);
						}
					}
				};
				this.$util.request(params);
			}
		},
		saveAddress() {
			let that = this;
			let params = {
				that: this,
				url: this.$config.service.modifyAll,
				data: that.formLabelAlign,
				cb(res) {
					if (res.code == 0) {
						that.loadData();
						that.isEditAddress = false
						that.$message.success(res.message)
					}
				}
			};
			this.$util.request(params);
		},
		saveHeader() {
			let that = this;
			let params = {
				that: this,
				url: this.$config.service.modifyUser,
				data: {
					headImg: this.header
				},
				cb(res) {
					if (res.code == 0) {
						that.formLabelAlign.heaPath = res.resultBody ? res.resultBody : that.touxiang
						that.$refs.myHeader.userInfo.heaPath = that.touxiang
						window.localStorage.setItem('headurl', that.formLabelAlign.heaPath);
						that.headerShow = false;
						// console.log('111', window.localStorage.getItem('userInfo'));
					}
				}
			};
			this.$util.request(params);
		},
		handleSuccess(res) {
			this.header = res.message
			// TODO: 上传成功后清理缓存，否则会导致头像无法上传
			this.$refs.upload.clearFiles()
		},
		handleRemove() {
			this.uploadPicUrl = this.touxiang
		},
		beforeAvatarUpload(file) {
			let size = file.size < (1024 * 1024 * 5)
			if (!size) {
				this.$message({
					message: this.$t('Personal.FileCannotExceed5MB'),
					type: 'warning'
				});
				return size
			}
			this.QiniuData.data = file;
		},
		closeBox() {
			this.headerShow = false;
		},
		avatar(url) {
			this.header=url
			this.headerShow = true;
		},
		loadData() {
			let that = this;
			let params = {
				url: this.$config.service.getAllUserBaseInfo,
				data: {},
				that: this,
				cb(res) {
					if (res.code == 0) {
						that.loadProvince();
						that.formLabelAlign = res.resultBody;
						console.log('用户信息',that.formLabelAlign)
						that.resPhoneNumber = that.formLabelAlign.contactNumber
						console.log('shouji',that.resPhoneNumber)
						// 对手机号中间后四位进行处理
						that.formLabelAlign.contactNumber = that.formLabelAlign.contactNumber.substr(0,3) + '****'+that.formLabelAlign.contactNumber.substr(7);
					}
				}
			};
			that.$util.request(params);
		},
		//查询省份 queryProvince
		loadProvince() {
			let that = this;
			let params = {
				url: this.$config.service.queryProvince,
				method: 'POST',
				data: {},
				that: this,
				cb(res) {
					if (res.code == 0) {
						that.provinceList = res.resultBody.datas;
						// console.log('城市',res)
					}
				}
			};
			that.$util.request(params);
		},
		loadLinkage(val) {
			this.formLabelAlign.province = val.name;
			console.log('222', this.formLabelAlign.province);
			console.log('111', val);
			let that = this;
			let params = {
				url: this.$config.service.queryLinkage,
				method: 'POST',
				data: {
					id: val.id
				},
				that: this,
				cb(res) {
					if (res.code == 0) {
						that.cityList = res.resultBody.datas;
						that.formLabelAlign.city = ''
						that.formLabelAlign.county = ''
						that.isEditAddress = true
					}
				}
			};
			that.$util.request(params);
		},
		loadXian(val) {
			this.formLabelAlign.city = val.name;
			let that = this;
			let params = {
				url: this.$config.service.queryLinkage,
				method: 'POST',
				data: {
					id: val.id
				},
				that: this,
				cb(res) {
					if (res.code == 0) {
						that.xianList = res.resultBody.datas;
						that.formLabelAlign.county = ''
					}
				}
			};
			that.$util.request(params);
		},
		loadCounty(val) {
			this.formLabelAlign.county = val.name;
		},
		onSubmit() {
			console.log('submit!');
		},
		close() {
			this.show = false;
		},
		passwordamend(type) {
			this.show = true;
			if (type == 1) {
				this.titleshow = 1;
			} else if (type == 2) {
				this.titleshow = 2;
			}
		},
		setPasswordChange() {
			if( this.titleshow == 1 ) {
				this.sureset()
			} else if ( this.titleshow == 2 ) {
				this.sure()
			}
		},
		sure() {
			//点击确定
			if (this.changePassword.oldPassword == '') {
				this.$message.error(this.$t('Personal.OldPasswordCannotEmpty'));
				return;
			}
			if (this.changePassword.newPassword == '') {
				this.$message.error(this.$t('Personal.NewPasswordCannotEmpty'));
				return;
			}
			if (this.changePassword.againnewPassword == '') {
				this.$message.error(this.$t('Personal.SecondaryPasswordCannotEmpty'));
				return;
			}
			if (this.changePassword.newPassword != this.changePassword.againnewPassword) {
				this.$message.error(this.$t('Personal.PasswordsEnteredDifferent'));
				return;
			}
			let that = this;
			let params = {
				url: this.$config.service.modifyPassword,
				data: {
					newPassword: that.changePassword.newPassword,
					oldPassword: that.changePassword.oldPassword,
					againnewPassword: that.changePassword.againnewPassword
				},
				that: this,

				cb(res) {
					console.log(res);
					if (res.code == 0) {
						//成功
						that.$message({
							message: that.$t('Personal.SuccessfullyModified'),
							type: 'success'
						});
						that.show = false;
					} else {
						//失败
						that.$message({
							message: res.message,
							type: 'error'
						});
						that.show = true;
					}
				}
			};
			that.$util.request(params);
		},
		sureset() {
			let that = this;
			let params = {
				url: this.$config.service.setuppassword,
				data: {
					newPassword: that.setupPassword.password
				},
				that: this,
				cb(res) {
					if (res.code == 0) {
						that.$message({
							message: that.$t('Personal.SuccessfullySet'),
							type: 'success'
						});
						that.show = false;
					}
				}
			};
			that.$util.request(params);
		},
		saveName(){
			let that = this;
			let params = {
				url: this.$config.service.modifyAll,
				method: 'POST',
				data: that.formLabelAlign,
				that: this,
				cb(res) {
					if (res.code == 0) {
						that.isEditName = true
						that.$message.success(res.message)
					}
				}
			};
			that.$util.request(params);
		},
		cancel(){
			let that = this
			if(that.formLabelAlign.city == ''|| that.formLabelAlign.county == ''){
				that.$message.error(that.$t('Personal.PleaseSelectCityOrCounty'))
				return false
			}
			that.isEditAddress = !that.isEditAddress
		},
		savePhoneNumber(num){
			if(num == 1){
				let data = {
					phone: this.phoneNumber,
					state:''
				}
				this.sendPhoneCode(data)
			} else { 
				let params = {
					that: this,
					method: 'POST',
					url: this.$config.service.bindUserPhone,
					data: {
						phone: that.phoneNumber,
						verificationcode: that.verificationCode
					},
					cb(res) {
						if (res.code == 0) {
							that.isEditName = true
							that.$message.success(res.message)
						}
					}
				};
				this.$util.request(params);
			}
			
		}
	},
	created() {
		this.loadData();
	}
};
</script>

<style scope lang="scss">
.personalBox{
	width: 1200px;
	margin: 30px auto;
	background: #fff;
	border-radius: 5px;
	.titleBox{
		margin: 0 50px;
		padding: 30px 0;
		display: flex;
		align-items: center;
		.p_line {
			width: 4px;
			height: 20px;
			background: #0080ff;
			margin-right: 15px;
		}
	}
	.personal-content {
		min-height: 500px;
		padding: 0 30px;
		padding-bottom: 20px;
		.contentItem{
			width: 800px;
			.itemBox{
				display: flex;
				align-items: center;
				.content{
					flex: 1;
					padding-right: 50px;
					position: relative;
					.headerImg{
						width: 80px;
						height: 80px;
						border: 1px solid #ccc;
						border-radius: 50%;
					}
					.tips{
						position: absolute;
						font-size: 12px;
						line-height: 20px;
						.asterisk{
							margin-right: 5px;
							color: red;
						}
						.tipsText{
							color: #c1c1c1;
						}
					}
				}
				.btnBox{
					width: 100px;
				}
			}
		}
	}
}
.borderCircle {
	width: 100px;
	height: 100px;
	border: 1px solid #cccccc;
	border-radius: 50%;
	margin-top: 37px;
}

.p_behind {
	width: 19%;
	height: 45px;
	margin-left: 40px;
}
.p_font {
	color: #0080ff;
	font-size: 14px;
	width: 19%;
	margin-left: 40px;
	cursor: pointer;
}
.img_heade {
	width: 100px;
	height: 100px;
	border-radius: 50%;
	margin-left: 30px;
}
.img_heade img {
	width: 79px;
	height: 79px;
	border-radius: 50%;
}
.personal-box {
	width: 100%;
	height: 100%;
	background: #f5f5f5;
	position: absolute;
}
.p_title span {
	font-size: 16px;
	color: #333;
}
.p_title {
	margin-top: 30px;
	margin-left: 50px;
}
.mask {
	position: fixed;
	left: 0;
	top: 0;
	z-index: 1001;
	width: 100%;
	height: 100%;
	background-color: #000;
	opacity: 0.3;
}
.details2 {
	/* 遮罩层内容 */
	position: fixed;
	opacity: 1;
	z-index: 2001;
	top: 20%; /*偏移*/
	left: 45%;
	width: 800px;
	margin-left: -300px;
	border-radius: 3px;
	overflow: auto;
	background: #fff;
	.headerShow {
		width: 100%;
		height: 50px;
		display: flex;
		justify-content: space-between;
		align-items: center;
		padding: 0 30px;
		box-sizing: border-box;
		.modifyHeader{
			font-size: 16px;
		}
		.close {
			font-size: 20px;
		}
	}
	.boxcontent {
		display: flex;
		justify-content: space-between;
		align-items: center;
		margin: 20px 0;
		padding: 0 30px;
		.boxLeft {
			width: 467px;
			height: 360px;
			display: flex;
			flex-direction: column;
			justify-content: center;
			align-items: center;
			background: #f5f7fc;
			border: 1px solid #0080ff;
			border-radius: 3px;
			.uploadTips{ 
				margin-top: 24px;
				font-size: 14px; 
				color: #c1c1c1;
			}
		}
		.boxRight{
			width: 240px;
			height: 360px;
			display: flex;
			flex-direction: column;
			justify-content: center;
			align-items: center;
			p {
				margin-top: -160px;
				font-size: 15px;
				color: #333333;
			}
			img {
				width: 100px;
				height: 100px;
				border: 1px solid #cccccc;
				border-radius: 50%;
				margin-top: 37px;
			}
			span {
				margin-top: 14px;
				color: #666666;
				font-size: 12px;
			}
		}
	}
	.buttonBox{
		display: flex;
		justify-content: center;
		padding-bottom: 20px;
	}
}

.phoneNumberBox{
	.phoneNumber{
		padding: 10px 0;
	}
	.tips{
		line-height: 15px;
	}
	
}
.phoneNumberBox /deep/ .el-form-item__content{
	line-height: 15px;
}

.modifyHeader {
	font-size: 18px;
	color: #333333;
}

.el-form-item__error {
	padding-left: 20px;
}
</style>
